import styled from 'styled-components';
import { ReactComponent as Back } from '../../assets/icons/back-icon-mobile.svg';

export const IconBack = styled(Back)`
  display: flex;
  width: 24px;
  height: 24px;

  @media (min-width: 960px) {
    display: none;
  }
  :hover {
    cursor: pointer;
  }
`;

export const ConfirmationRoot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  .content {
    width: 100%;
    padding: 24px 20px;

    @media (min-width: 960px) {
      width: 624px;
      padding: 0;
      margin-top: 40px;
    }

    .questions {
      display: flex;
      flex-direction: column;
      .question-title {
        font-family: ${(props) => props.theme.primaryFont};
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 17px;
        text-transform: uppercase;
        color: #222222;
        margin-bottom: 16px;
      }

      .question {
        font-family: ${(props) => props.theme.primaryFont};
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 120%;
        color: #222222;
        margin-bottom: 20px;
      }
      .question-options {
        display: flex;
        flex-direction: row;
        margin-bottom: 30px;
        margin-top: 20px;
        .answer-yes {
          display: flex;
          flex-direction: row;
          margin-right: 40px;
          span {
            font-family: ${(props) => props.theme.primaryFont};
            font-style: normal;
            font-weight: normal;
            font-size: 20px;
            line-height: 24px;
            color: #222222;
          }
        }
        .answer-no {
          display: flex;
          flex-direction: row;

          span {
            font-family: ${(props) => props.theme.primaryFont};
            font-style: normal;
            font-weight: normal;
            font-size: 20px;
            line-height: 24px;
            color: #222222;
          }
        }
      }
    }
  }

  .footer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;

  .title {
    font-family: ${(props) => props.theme.primaryFont};
    font-style: normal;
    font-weight: bold;
    color: #070c2f;
    margin-left: 8px;
    font-size: 24px;
    line-height: 30px;

    @media (min-width: 960px) {
      margin-left: 0;
      font-size: 28px;
      line-height: 35px;
    }
  }

  .step-title {
    font-family: ${(props) => props.theme.primaryFont};
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
    text-transform: uppercase;
    color: #222222;
  }

  .sub-section-header {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 30px;

    @media (min-width: 960px) {
      justify-content: space-between;
    }
  }

  .title-section-header {
    display: flex;
    align-items: center;
    margin-right: 28px;
  }

  .step-counter {
    display: none;
    @media (min-width: 960px) {
      display: contents;
    }
  }

  .step-counter-mobile {
    display: contents;
    @media (min-width: 960px) {
      display: none;
    }
  }
`;

export const SectionCards = styled.div<{ hiddeStep: boolean }>`
  display: ${(props) => props.hiddeStep && 'none'};
  margin-bottom: 44px;
`;

export const Button = styled.button<{ color: string; loading?: boolean }>`
  height: 60px;
  color: ${(props) =>
    props.color === 'primary'
      ? props.theme.colors.white
      : props.theme.colors.primary};
  background: ${(props) =>
    props.color === 'primary'
      ? props.theme.colors.primary
      : props.theme.colors.white};
  text-transform: uppercase;
  padding: ${(props) => (props.loading ? '0 24px' : '19px 24px')};
  box-shadow: 0px 4px 4px rgba(36, 36, 36, 0.2);
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '16px'};
  font-size: 16px;
  font-weight: bold;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const SelectContainer = styled.div<{ selected?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${(props) =>
    `2px solid ${props.selected ? props.theme.colors.primary : '#7B86A3'}`};
  height: 24px;
  width: 24px;
  border-radius: 50%;
  align-self: center;
  margin-right: 16px;

  cursor: pointer;
  span {
    background: ${(props) =>
      props.selected ? props.theme.colors.primary : 'none'};
    align-self: center;
    justify-self: center;
    height: 14px;
    width: 14px;
    border-radius: 50%;
  }
`;
